import { NgModule } from '@angular/core';
import { SharedModule } from "../../shared/shared.module";

import { FooterComponent } from './footer.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        FooterComponent
    ],
    exports: [
        FooterComponent
    ]
})

export class FooterModule {}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/moddules/footer/footer.module.ts